import {
    LineChart,
    SimpleWeightLog,
} from '@/features/programs/shared/ui/LineChart';
import React from 'react';
import { createRoot } from 'react-dom/client';

export function WeightChartApp(
    containerQuery: string,
    data: SimpleWeightLog[],
) {
    const elm = document.querySelector(containerQuery);
    const root = createRoot(elm);
    root.render(<App data={data} />);
}

const App = ({ data }: { data: SimpleWeightLog[] }) => {
    return (
        <div className="h-full w-full">
            <LineChart data={data} />
        </div>
    );
};
